import { PlantStorageOnlyMetrics } from '@/features/plants/components/plant-overview/storage-only/components/plant-storage-only-metrics.tsx';
import { useGetPlantDevicesOverviewQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant-devices-overview.ts';
import { getTodayDateRange } from '@/utils/get-today-date-range.ts';
import { DeviceTreeTableCard } from '@/features/devices/components/device-tree-table/device-tree-table-card.tsx';
import { cn } from '@/utils/utils.ts';
import { useGetPlantDevicesQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-devices-plant.ts';
import { PlantEvents } from '@/features/plants/components/plant-events/plant-events.tsx';
import style from '@/features/plants/components/plant-overview/production-and-storage/advanced/plant-production-and-storage-overview-advanced.module.scss';
import { MultiDeviceMetricsTableCard } from '@/features/devices/components/multi-device-metrics-table/multi-device-metrics-table-card.tsx';
import { DEVICE_TYPES_NAMES_ARRAY } from '@/features/devices/schemas/devices.schemas.ts';
import { usePermissions } from '@/hooks/use-permission';
import { PlantStorageOnlyEnergyManagement } from './plant-storage-only-energy-management';
import { PlantStorageOnlyDetailsCard } from '@/features/plants/components/plant-overview/storage-only/components/plant-storage-only-flow-and-charge-discharge-chart.tsx';

const PlantStorageOnlyOverview = ({
  plantId,
  isLoading: isPlantLoading,
}: {
  plantId: string | undefined;
  isLoading?: boolean;
}) => {
  const [canEditStorageFields] = usePermissions<'plants'>([
    ['plants', 'edit.plant.storage-fields'],
  ]);

  const { data: plantDevices, isLoading: isDevicesLoading } = useGetPlantDevicesQuery({
    plantId,
    enabled: Boolean(plantId),
  });

  const { data: devicesOverview, isLoading: isDevicesOverviewLoading } =
    useGetPlantDevicesOverviewQuery({
      plantId,
      enabled: Boolean(plantId),
      dateRange: getTodayDateRange(),
    });

  const isLoading = isPlantLoading || isDevicesLoading || isDevicesOverviewLoading;

  return (
    <div className={cn(style.grid_container)}>
      <div className={cn(style.grid, 'gap-6')}>
        <PlantStorageOnlyMetrics plantId={plantId} className={style.today_metrics} />

        <PlantStorageOnlyDetailsCard
          plantId={plantId}
          className={cn(style.realtime_metrics, 'min-h-[490px]')}
        />

        <PlantStorageOnlyEnergyManagement
          isLoading={isLoading}
          plantId={plantId}
          className={cn(style.energy_management_chart, 'min-h-[440px] sm:min-h-[535px]')}
        />

        <DeviceTreeTableCard
          title="Device"
          data={plantDevices ?? []}
          isLoading={isLoading}
          className={cn(style.devices)}
        />

        <MultiDeviceMetricsTableCard
          data={devicesOverview?.storage}
          config={devicesOverview?.config?.storage}
          type={'storage'}
          deviceTypes={DEVICE_TYPES_NAMES_ARRAY}
          isLoading={isLoading}
          plantId={plantId || ''}
          title="Overview Battery"
          className={style.production}
          showSelectFields={canEditStorageFields}
        />
        <PlantEvents className={style.events} />
      </div>
    </div>
  );
};

export default PlantStorageOnlyOverview;
